import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { ConfigContext, globalConfig, Modal } from "@pionex-web-kit/components";
import { IconClose16pxRegular } from "@pionex-web-kit/icons";
import csn from "classnames";
import React, { useContext, useState } from "react";
import { useTranslators } from "../hooks/Locale";
import { Faq } from "./Faq";
import { InputContact } from "./InputContact";
import { SignGuide } from "./SignGuide";
import { HelpCenterPage } from "./types";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export { HelpCenterPage };
export var HelpCenter = function HelpCenter(_ref) {
  var questions = _ref.questions,
    close = _ref.close,
    onSign = _ref.onSign,
    desc = _ref.desc,
    defaultPage = _ref.defaultPage;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls("helpCenter");
  var _useState = useState(defaultPage !== null && defaultPage !== void 0 ? defaultPage : HelpCenterPage.faq),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var _useTranslators = useTranslators(),
    $st = _useTranslators.$st;
  function renderPage() {
    if (page === HelpCenterPage.sign) {
      return /*#__PURE__*/_jsx(SignGuide, {
        navigate: setPage,
        close: close,
        onSign: onSign
      });
    } else if (page === HelpCenterPage.contact) {
      return /*#__PURE__*/_jsx(InputContact, {
        close: close
      });
    }
    return /*#__PURE__*/_jsx(Faq, {
      navigate: setPage,
      questions: questions,
      close: close,
      desc: desc
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: prefixCls,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "".concat(prefixCls, "-title-wrap"),
      children: [/*#__PURE__*/_jsx("div", {
        className: csn("".concat(prefixCls, "-title"), _defineProperty({}, "".concat(prefixCls, "-title-hidden"), page !== HelpCenterPage.faq)),
        children: $st("customer_service_center")
      }), /*#__PURE__*/_jsx("div", {
        className: "".concat(prefixCls, "-close-btn"),
        onClick: function onClick() {
          close === null || close === void 0 ? void 0 : close();
        },
        children: /*#__PURE__*/_jsx(IconClose16pxRegular, {
          size: 16
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(prefixCls, "-content"),
      children: renderPage()
    })]
  });
};
var modalRef = {
  current: null
};
/**
 * 打开客服中心
 */
export var openHelpCenter = function openHelpCenter(modal, helpCenterProps) {
  var _modalRef$current;
  Modal.destroyAll();
  (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.destroy();
  var _globalConfig = globalConfig(),
    getPrefixCls = _globalConfig.getPrefixCls;
  var prefixCls = getPrefixCls("helpCenter-modal");
  modalRef.current = modal.info({
    wrapClassName: "".concat(prefixCls, "-wrap"),
    className: prefixCls,
    mask: false,
    transitionName: "",
    zIndex: 1999999,
    okButtonProps: {
      hidden: true
    },
    content: /*#__PURE__*/_jsx(HelpCenter, _objectSpread(_objectSpread({}, helpCenterProps), {}, {
      close: function close() {
        var _modalRef$current2;
        return (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 ? void 0 : _modalRef$current2.destroy();
      }
    }))
  });
};